import { cn } from "@/lib/utils";

type AppBackgroundProps = {
    className?: string;
    variant?: "default" | "subtle";
};

export function AppBackground({ className, variant = "default" }: AppBackgroundProps) {
    const glowOpacity = variant === "subtle" ? "0.05" : "0.07";

    return (
        <div aria-hidden className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}>
            <div
                className="absolute inset-x-0 top-0 h-[520px] dark:hidden"
                style={{
                    background:
                        "radial-gradient(ellipse 80% 55% at 50% -15%, color-mix(in oklch, var(--chart-2) 7%, transparent), transparent)",
                }}
            />
            <div
                className="absolute inset-x-0 top-32 h-[360px] dark:hidden"
                style={{
                    background: `radial-gradient(ellipse 60% 40% at 80% 0%, color-mix(in oklch, var(--chart-3) ${glowOpacity}, transparent), transparent)`,
                }}
            />
            <div className="app-grain absolute inset-0 dark:opacity-[0.03]" />
        </div>
    );
}
